import { UserOutlined } from '@ant-design/icons';
import { Avatar, Typography } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import { useState } from 'react';

import BookAuthorsModal from '@/components/BookLandingPageComp/HeroSection/ViewAllAuthorsModal';
import { ShouldRender } from '@/components/shared/basic/ShouldRender';

import { IAuthorDetailsList } from '@/utils/interfaces/landingPage';

const { Text } = Typography;

const AuthorInfo = ({ authorsData }: { authorsData: IAuthorDetailsList[] }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const MAX_VISIBLE = 3;
  const screens = useBreakpoint();

  return (
    <>
      <div
        onClick={() => setIsModalOpen(true)}
        className='flex items-center gap-x-3 text-white cursor-pointer'
      >
        <Avatar.Group>
          {authorsData.slice(0, MAX_VISIBLE).map((author, index) => (
            <Avatar
              src={author.authorImage}
              icon={!author.authorImage && <UserOutlined />}
              size={screens?.md ? 44 : 36}
              alt='Author Avatar'
              key={`author-${index}`}
            />
          ))}
          <ShouldRender check={authorsData.length > MAX_VISIBLE}>
            <Avatar
              size={screens?.md ? 44 : 36}
              style={{ backgroundColor: '#282829' }}
            >
              +{authorsData.length - MAX_VISIBLE}
            </Avatar>
          </ShouldRender>
        </Avatar.Group>

        {/* Author Designation */}
        <div className='flex flex-col'>
          <Text className='text-xs md:text-sm font-light text-grayZl-500'>
            Multiple Authors from
          </Text>
          <Text className='text-xs md:text-sm font-medium text-white'>
            Top Companies and Institutes
          </Text>
        </div>
      </div>
      <BookAuthorsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        authors={authorsData}
      />
    </>
  );
};

export default AuthorInfo;
